<template>
    <form @submit.prevent="submit" method="POST" >

        <slot></slot>

        <div class="form-group">
            <label for="model-name">Project Name</label>
            <input type="text" v-model="model.name" autocomplete="off"
                   required
                   id="model-name"
                   class="form-control"
                   placeholder="Stack overflow curating">
            <small id="project-name-help" class="form-text text-muted">
                What's a project? Well, anything you want to track time for.
            </small>
        </div>

        <div class="form-group">
            <label for="model-client">Client</label>
            <b-form-select id="model-client"
                           v-model="model.client_id"
                           :options="clientSelectorOptions">
            </b-form-select>
        </div>

        <div class="form-group">
            <label for="hourly-rate">Hourly Rate</label>
            <input type="number" v-model="model.rate"
                   id="hourly-rate"
                   step="0.1" min="0" max="1000" class="form-control" placeholder="">
            <small class="form-text text-muted" id="hourly-rate-help">
                You can enter an hourly rate if you want automatic earnings calculations
            </small>
        </div>

        <button :style="{display: submitDisplay}" type="submit"
                class="btn btn-secondary" ref="submitBtn"><i class="fas fa-plus"></i> Add Project</button>
    </form>
</template>

<script>
    import {BFormSelect} from 'bootstrap-vue';
    Vue.component('b-form-select', BFormSelect);

    export default {
        name: "ProjectForm",

        props: [
            "project",
            "clients",
        ],

        mounted () {
            //console.log("I mounted now..", this.project, this.clients);
            //console.log(this.clients);
        },

        watch: {
            project(newVal) {
                if (!newVal) return ;

                //console.log("Loading new model into edit form.", newVal);

                this.model = _.extend({}, {
                    id: newVal.id,
                    name: newVal.name,
                    rate: newVal.rate,
                    client_id: newVal.client_id,
                });
            }
        },

        data() {
            return {
                model: _.extend({client_id: 0}, this.project),
            }
        },

        computed: {
            submitDisplay() {
                return this.model.id ? "none" : false;
            },
            clientSelectorOptions() {
                const emptyOptions = [{value: 0, text: "--"}];
                if (!this.clients || this.clients.length === 0) {
                    return emptyOptions;
                }

                return _.concat(
                    emptyOptions,
                    _.map(this.clients, function(el) {
                        return {
                            value: el.id,
                            text: el.name
                        }
                    })
                );
            },
        },

        methods: {
            // used for parent components to atempt submitting "from outside"
            sendSubmitSignal() {
                this.$refs.submitBtn.click();
            },

            submit(e) {
                if (this.model.rate) {
                    this.model.rate = parseFloat(this.model.rate)
                }

                var that = this;

                if (!this.model.id) {
                    // create operation
                    window.axios.post("api/project", this.model)
                        .then(function(resp){
                            that.$emit("created", resp.data.model);
                            that.model = {client_id: 0};
                        })
                        .catch(function(error){
                            console.log(error);
                        });
                } else {
                    // update operation
                    window.axios.put("api/project/" + this.model.id, this.model)
                        .then(function(resp){
                            that.$emit("updated", resp.data.model);
                        })
                        .catch(function(error){
                            console.log(error);
                        });
                }
            }
        }
    }
</script>
